export default __webpack_public_path__ + "static/media/level_star_03.52461ae2.svg";